/**
 * @param array - Array to search through
 * @param predicate - Predicate function to test each element. We will return the index of the first one which returns true.
 * @param startIndex - Inclusive index to start searching from
 * @param endIndex - Exclusive end index to stop searching before
 */
export const findIndexFrom = <T>(
  array: T[],
  predicate: (item: T) => boolean,
  startIndex: number = 0,
  endIndex: number = array.length,
): number => {
  for (let i = startIndex; i < endIndex; i++) {
    if (predicate(array[i])) {
      return i;
    }
  }

  return -1;
};

/**
 * @param array - Array to search
 * @param predicate - Predicate function to test each element. We will return the first one which returns true.
 * @param startIndex - Inclusive index to start searching from
 * @param endIndex - Exclusive end index to stop searching before
 */
export const findFrom = <T>(
  array: T[],
  predicate: (item: T) => boolean,
  startIndex: number = 0,
  endIndex: number = array.length,
): T | undefined => {
  const index = findIndexFrom(array, predicate, startIndex, endIndex);
  // Indexing on -1 is undefined, so we can just return the item at the returned index
  return array[index];
};
